import React, { memo, useEffect, useState } from 'react';
import classNames from 'classnames';
import Grid from '../../../../helpers/AgGridTable';
import config from '../../../../../config';
import DatePickerEditor from '../DatePickerEditor';
import { DateRender } from '../DateRender';
import { GridCard } from '../../../../helpers/GridCard';

import style from './style.module.css';

const FundCompaniesComponent = ({
  loading,
  funds,
  page,
  totalPages,
  onSort,
  onGetNext,
  onRowDoubleClick,
  onCellClick,
  onCellValueChange,
  onRef,
}) => {
  const [gridApi, setGridApi] = useState(null);

  useEffect(() => {
    if (gridApi) {
      gridApi.sizeColumnsToFit();
    }
  }, [gridApi]);

  const getColumnDefs = () =>
    config.tables.getIn(['fund', 'buyer', 'columnDefs', 'columns']).map(column => {
      if (column.get('field') === 'dateAcquired') {
        return column.merge({
          cellRendererFramework: DateRender,
          cellEditorFramework: DatePickerEditor,
        });
      }

      return column;
    });

  const handleGridReady = params => {
    const { api } = params;

    api.sizeColumnsToFit();
    setGridApi(api);
    if (onRef) {
      onRef(params);
    }
  };

  const getRowNodeId = data => data.order?.toString();

  return (
    <GridCard className={classNames(style.host, 'flexItem')} title="Current">
      <Grid
        columnDefs={getColumnDefs()}
        getRowNodeId={getRowNodeId}
        isFetching={loading}
        onCellClicked={onCellClick}
        onCellValueChanged={onCellValueChange}
        onGetNextPageData={onGetNext}
        onGridReady={handleGridReady}
        onRowDoubleClicked={onRowDoubleClick}
        onSortModelChanged={onSort}
        page={page}
        rowData={funds}
        totalPages={totalPages}
        sortable
      />
    </GridCard>
  );
};

/** Fund companies component. */
export const FundCompanies = memo(FundCompaniesComponent);
